import React from "react";
import { Copy, Link } from "react-feather";
import toast from "react-hot-toast";
import { Badge } from "reactstrap";
import { limitCaracter } from "utils";
import { boolean } from "yup";

const NewBadge = props => {
  const {
    color = "primary",
    value,
    isCopy = false,
    className,
    title,
    valueCopy,
    isLimitCaracter = false,
    limitText = 5,
    ...rest
  } = props;
  const handleCopy = value => {
    if (valueCopy) {
      navigator.clipboard.writeText(valueCopy);
    } else {
      navigator.clipboard.writeText(value);
    }
    return toast.success(`Copiou ${valueCopy ? valueCopy : value}`);
  };

  return (
    <Badge
      style={{ cursor: isCopy && "Pointer", margin: "3px" }}
      onClick={() => isCopy && handleCopy(value)}
      color={color}
      className={className}
      title="Copiar"
      {...rest}
    >
      {title || ""}&nbsp;
      {isLimitCaracter ? limitCaracter(limitText, value) : value}&nbsp;
      {isCopy && <Copy size={11} />}
    </Badge>
  );
};

const NewLinkBadge = props => {
  const {
    color = "primary",
    value,
    isLink = "",
    className,
    title,
    valueLink,
    ...rest
  } = props;
  const handleLink = value => {
    if (valueLink) {
      window.open(valueLink, "_blank", "noopener,noreferrer");
    } else {
      window.open(value);
    }
    toast.success(`Você foi direcionado para a tela do cliente ${value}`);
  };
  return (
    <Badge
      style={{ cursor: isLink && "Pointer", margin: "0.5px" }}
      onClick={() => isLink && handleLink(value)}
      color={color}
      className={className}
      title="Abrir APP do Cliente"
      {...rest}
    >
      {isLink && <Link size={11} />}
    </Badge>
  );
};

NewBadge.AppProps = {
  color: String,
  value: String || JSX.Element || [],
  isCopy: boolean,
  className: String,
};

NewLinkBadge.AppProps = {
  color: String,
  value: String || JSX.Element || [],
  isLink: String,
  className: String,
};

export default NewBadge;
export { NewLinkBadge };
